import { Swiper } from './swiper.min.js'

export const globalFN = {
  init: function() {
    this.selectBtn('.btn_select');
    // txtCopy ();

    $('.btn_open_menu').on('click',function () {
      if(!$(this).hasClass('open')) {
        $(this).addClass('open').siblings('.gnb').addClass('show');
        $('.hlogo').addClass('on');
      }else {
        $(this).removeClass('open').siblings('.gnb').removeClass('show');
        $('.hlogo').removeClass('on');
      }
    });
  },
  swiper_init: function() {
     // 스와이퍼옵션
     var swiperOpt = {speed : 1000, delay : 5000 , bgAni : '6s', txtAni : '5s', txtAni : '.7s'} 
    
     // 스와이퍼 옵션 
     // speed : 스와이퍼 이동 속도, (1000 = 1초)
     // delay : 스와이퍼 딜레이 속도 (1000 = 1초)
     // bgAni : 이미지 애니메이션 속도 (1s = 1초)
     // txtAni : 텍스트 애니메이션 속도 (1s = 1초)
     // txtAni : 텍스트 애니메이션 딜레이 속도 (1s = 1초)
 
     $('.item.swiper-slide .kv_bg').css('animation-duration', swiperOpt.bgAni);
     $('.item.swiper-slide .kv_text').css({'animation-duration': swiperOpt.txtAni, 'animation-delay' : swiperOpt.txtDelay});
 
     
     var mainSwiper = new Swiper('.kv_items', {
       effect: "fade",
       speed: swiperOpt.speed,
       loop: true,
       autoplay: {
         delay: swiperOpt.delay,
         disableOnInteraction: false,
       },
       pagination: {
         el: '.kv_inner .swiper-pagination',
         type: 'bullets',
         clickable: true,
       }
     });
  },
  parallaxFn: function () {
    var	_wh = $(window).height();
    var _sct = $(window).scrollTop();
    var $section = $('.main_sec_prods'); 
    var _target = $section.find('.img');
    var _secH = $section.innerHeight();
    // var _bottom = _secH - 50;
    var _bottom = _target.outerHeight() -80;
    // var _ot = $section.offset().top + 200;
    var _ot = $section.offset().top + _bottom + 10;
  
    var _start = _sct + _wh;
    var _stop = _ot + _secH + _wh;
  
    var _bttm1 = -_bottom + ((_start - _ot) * .5) > -100 ? -100 : -_bottom + ((_start - _ot) * .5);
  
  
    if (_start >= _ot && _start <= _stop) {
      _target.css({
        bottom: _bttm1
      })
    }else if (_start > _stop ) {
      _target.css({
        bottom: -_bottom + ((_wh + _secH) * .5)
      })
    }else {
      _target.css({
        bottom: - _bottom
      })
    };
  },
  selectBtn: function (el) {
    var $btn = el,
      $list = $('.select_list'),
      $listBtn = $($list).find('li');
    $($btn).on('click',function () {
      var $this = $(this);
      $this.hasClass('on') ? $this.removeClass('on').siblings($list).fadeOut(100) : $this.addClass('on').siblings($list).fadeIn(100);
    });
    $($listBtn).on('click','button',function () {
      var $this = $(this),
        _txt = $(this).text(),
        $selBtn = $this.closest($list).siblings($btn);
      $this.parent().addClass('on').siblings().removeClass('on').closest($list).fadeOut(100);
      $selBtn.removeClass('on').find('span').text(_txt);
    });
  },
  txtCopy: function () {
    var $copyTxt = document.querySelector(".txtCopy");
    $copyTxt.select();
    $copyTxt.setSelectionRange(0, 99999)
    document.execCommand("copy");
  
    if($('.txtCopy').parent().find('.toast_wrap').length < 1) {
      $('.txtCopy').parent().append('<div class="toast_wrap"></div>')
    }
  
    var $wrapper = $('.toast_wrap')
    var _msg = $('<div class="toast_inner">메일주소가 복사되었습니다</div>');
    var _msgBox = _msg.appendTo($wrapper)
  
    _msg.appendTo($wrapper)
    $wrapper.show();
    setTimeout(function () {
      _msgBox.addClass('active');
    },300)
    
    _msgBox.delay(1500).queue(function() {
      $(this).removeClass('active');
      if($(this).closest('.toast_wrap').find('.active').length < 1) {
        setTimeout(function () {
          $('.toast_wrap').remove();
        }, 400)	
      }
    })
  }
}





// WEBPACK FOOTER //
// ./src/assets/js/custom.js